"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loveId = void 0;
const platform_1 = require("@hcengineering/platform");
exports.loveId = 'love';
const love = (0, platform_1.plugin)(exports.loveId, {
    class: {
        Room: '',
        Floor: '',
        Office: '',
        ParticipantInfo: '',
        PendingRecording: '',
        DevicesPreference: '',
        RoomInfo: '',
        MeetingMinutes: '',
        UserMeetingInvite: ''
    },
    mixin: {
        MeetingEventLink: '',
        MeetingSchedule: ''
    },
    action: {
        ToggleMic: '',
        ToggleVideo: ''
    },
    string: {
        Office: '',
        MyOffice: '',
        Room: '',
        IsKnocking: '',
        KnockingLabel: '',
        InvitingYou: '',
        MeetingRequest: '',
        Kind: '',
        RoomType: '',
        StartTranscription: '',
        StopTranscription: '',
        Meeting: '',
        Transcription: '',
        TranscriptionState: '',
        TranscriptionNotStarted: '',
        TranscriptionTranscribing: '',
        TranscriptionFinished: '',
        StartWithTranscription: '',
        // Guest join labels
        GuestFirstName: '',
        GuestLastName: '',
        // Start-with toggles for guest join
        StartWithVideo: '',
        StartWithAudio: '',
        MeetingMinutes: '',
        MeetingsMinutes: '',
        StartMeeting: '',
        Video: '',
        NoMeetingMinutes: '',
        JoinMeeting: '',
        JoinedMeeting: '',
        Accept: '',
        Decline: '',
        Join: '',
        Reject: '',
        MeetingStart: '',
        MeetingEnd: '',
        Status: '',
        Active: '',
        Finished: '',
        Pending: '',
        StartWithRecording: '',
        StartPrivate: '',
        RecordingState: '',
        RecordingNotStarted: '',
        RecordingRecording: '',
        RecordingFinished: '',
        Summary: '',
        Recording: '',
        StoppingRecord: '',
        Kick: '',
        EndMeeting: '',
        SearchMeetingMinutes: '',
        FinishMeeting: '',
        AddParticipant: '',
        LeaveParticipant: '',
        KnockAction: '',
        KnockingTo: '',
        KnockDeclined: '',
        OnlyOwnersCanInvite: '',
        NoHostOffice: '',
        NoHostOfficeBody: '',
        CallDeclined: '',
        CallDeclinedBody: '',
        WaitingForMeeting: '',
        WaitingForMeetingFrom: '',
        MeetingDeclinedOrFinished: '',
        CancelKnock: '',
        AdmitKnock: '',
        DeclineKnock: '',
        ShowParticipants: '',
        HideParticipants: '',
        Scheduled: '',
        ScheduledIn: '',
        WaitForHost: '',
        CloseRoom: '',
        OpenRoom: '',
        Private: '',
        Busy: '',
        // Viewlet-related strings
        ShowArchived: '',
        HideArchived: '',
        IncludeArchived: '',
        MeetingMinutesList: '',
        MeetingMinutesTable_: '',
        RoomsTable: '',
        RoomsList: '',
        RoomsFloor: '',
        GroupByRoom: '',
        GroupByOwner: '',
        GroupByStatus: '',
        GroupByDate: ''
    },
    ids: {
        MainFloor: '',
        Reception: '',
        LoveWidget: '',
        MeetingWidget: '',
        LoveNotificationGroup: '',
        InviteNotification: ''
    },
    icon: {
        Love: '',
        LeaveRoom: '',
        EnterRoom: '',
        Mic: '',
        MicEnabled: '',
        MicDisabled: '',
        Cam: '',
        CamEnabled: '',
        CamDisabled: '',
        SharingEnabled: '',
        SharingDisabled: '',
        Open: '',
        Knock: '',
        DND: '',
        Record: '',
        StopRecord: '',
        FullScreen: '',
        ExitFullScreen: '',
        Invite: '',
        Kick: '',
        MeetingMinutes: ''
    },
    sound: {
        Knock: '',
        MeetingEndNotification: ''
    },
    metadata: {
        WebSocketURL: '',
        ServiceEndpoint: ''
    },
    space: {
        Drive: ''
    },
    component: {
        SelectScreenSourcePopup: '',
        GuestMeetingApp: '',
        RoomMeetingsFooter: '',
        MeetingMinutesBreadcrumb: '',
        MeetingMinutesView: '',
        RoomsView: '',
        MeetingMinutesListItem: '',
        RoomListItem: '',
        RoomTablePresenter: '',
        FloorMeetingMinutesList: '',
        RoomAttributePresenter: '',
        MeetingMinutesMessagesPresenter: '',
        MeetingMinutesTranscriptionPresenter: ''
    },
    viewlet: {
        TableMeetingMinutes: '',
        TableMeetingMinutesEmbedded: '',
        MeetingMinutesDescriptor: '',
        FloorDescriptor: '',
        Floor: '',
        FloorMeetingMinutes: '',
        ListMeetingMinutes: '',
        ListMeetingMinutesDescriptor: '',
        FloorMeetingMinutesListViewlet: '',
        TableRooms: '',
        TableRoomsDescriptor: '',
        ListRooms: '',
        ListRoomsDescriptor: ''
    }
});
exports.default = love;
//# sourceMappingURL=plugin.js.map